import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RouterSelectors } from '@next/core-lib/router-store';
import { SiteState } from '@next/core-lib/site';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

import appData from '../../../shared/appData';
import { Customer } from '../../../shared/models/shared.model';
import { upsertCustomerRequest } from '../../store/customer.actions';
import { getSelectedCustomer } from '../../store/customer.selectors';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  standalone: false,
})
export class CustomerDetailComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  countries = appData.countries;

  form: FormGroup = new FormGroup({
    id: new FormControl(null),
    name: new FormControl(null, Validators.required),
    emailAddress: new FormControl(null, [Validators.required, Validators.email]),
    street: new FormControl(null),
    postalCode: new FormControl(null),
    houseNumber: new FormControl(null, [Validators.min(1)]),
    houseNumberAddition: new FormControl(null),
    city: new FormControl(null),
    country: new FormControl(null),
    phoneNumber: new FormControl(null),
    mobileNumber: new FormControl(null),
  });

  customer$: Observable<Customer> = this.store.select(getSelectedCustomer);

  details$: Observable<Customer> = this.customer$.pipe(
    filter((val) => !!val && Object.entries(val).length > 0),
    take(1),
  );

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getUrl));

  save() {
    if (this.form.valid) {
      this.customer$.pipe(take(1)).subscribe((customer) => {
        this.store.dispatch(
          upsertCustomerRequest({
            customer: { ...this.form.value, id: customer ? customer.id : undefined },
          }),
        );
      });
    }
  }
}
